import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {addPushTokenRotationListener, registerPushDevice} from "@/lib/push-notifications";

/**
 * Keeps this device's push registration current for as long as a user is logged in. Only ever
 * mounted inside <Authenticated> — registering is an authenticated call.
 *
 * Re-runs on every language change because the backend renders each push in the locale stored on
 * the device row, so a user who switches to German while logged in would otherwise keep receiving
 * English pushes until the next reinstall. Re-registering is a single idempotent request.
 */
export function usePushRegistration() {
    const {i18n} = useTranslation();
    const locale = i18n.language;

    useEffect(() => {
        void registerPushDevice(locale);

        // Re-subscribing on every locale change is what keeps this callback reading the current
        // one; the subscription itself is cheap.
        return addPushTokenRotationListener(() => {
            void registerPushDevice(locale);
        });
    }, [locale]);
}
